import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { LabelType, Period } from 'graphql/types';
import { useLabels } from 'modules/common/hooks';

export const useLabelVisibility = (
  currentPeriod: Period
): {
  CLIENT: boolean;
  PROGRAM: boolean;
  PROJECT: boolean;
  TASK: boolean;
  SELECT: boolean;
  ACTIVITY: boolean;
} => {
  const { endDate } = currentPeriod ?? {};
  const asOfDate = useMemo(() => {
    const now = DateTime.local();
    if (endDate) {
      const end = DateTime.fromISO(endDate);
      if (end >= now) {
        return now;
      }
      return end;
    }
    return now;
  }, [endDate]);

  const { timesheetLabels } = useLabels(asOfDate);

  const labelVisibility = {
    CLIENT: false,
    PROGRAM: false,
    PROJECT: false,
    TASK: false,
    SELECT: false,
    ACTIVITY: false
  };
  timesheetLabels.forEach((item) => {
    if (item.type === LabelType.Client) labelVisibility.CLIENT = true;
    if (item.type === LabelType.Program) labelVisibility.PROGRAM = true;
    if (item.type === LabelType.Project) labelVisibility.PROJECT = true;
    if (item.type === LabelType.Task) labelVisibility.TASK = true;
    if (item.type === LabelType.Select) labelVisibility.SELECT = true;
    if (item.type === LabelType.Activity) labelVisibility.ACTIVITY = true;
  });
  return labelVisibility;
};
